import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['text', 'toggle']

  connect() {
    if (!this.hasTextTarget || !this.hasToggleTarget) return

    requestAnimationFrame(() => this.syncToggle())

    this.resizeObserver = new ResizeObserver(() => {
      if (!this.expanded) this.syncToggle()
    })
    this.resizeObserver.observe(this.textTarget)
  }

  disconnect() {
    if (this.resizeObserver) this.resizeObserver.disconnect()
  }

  get expanded() {
    return this.element.classList.contains('is-expanded')
  }

  toggle(event) {
    event.preventDefault()
    this.setExpanded(!this.expanded)
  }

  setExpanded(expanded) {
    this.element.classList.toggle('is-expanded', expanded)
    this.toggleTarget.textContent = expanded ? 'less' : 'more'
    this.toggleTarget.setAttribute('aria-expanded', String(expanded))
    this.toggleTarget.hidden = false

    if (!expanded) {
      this.textTarget.addEventListener('transitionend', () => this.syncToggle(), { once: true })
    }
  }

  syncToggle() {
    if (!this.hasTextTarget || !this.hasToggleTarget) return
    this.toggleTarget.hidden = !this.isOverflowing() && !this.expanded
  }

  // -webkit-line-clamp makes scrollHeight === clientHeight; measure a full-height clone instead.
  isOverflowing() {
    const el = this.textTarget
    if (!el.clientWidth) return false

    const clone = el.cloneNode(true)
    clone.style.cssText = [
      `width: ${el.clientWidth}px`,
      'position: absolute',
      'visibility: hidden',
      'height: auto',
      'max-height: none',
      'display: block',
      '-webkit-line-clamp: unset',
      'overflow: visible'
    ].join(';')

    el.parentNode.appendChild(clone)
    const overflowing = clone.scrollHeight > el.clientHeight + 1
    clone.remove()

    return overflowing
  }
}
